import apiClient from '../apiClient';
import type { ApiResponse, AuthResponse, LoginRequest, User } from '@/types';

const BASE_URL = '/auth';

export const login = async (credentials: LoginRequest): Promise<AuthResponse> => {
  const { data } = await apiClient.post<ApiResponse<AuthResponse>>(`${BASE_URL}/login`, credentials);
  const { accessToken, refreshToken } = data.data;
  localStorage.setItem('accessToken', accessToken);
  localStorage.setItem('refreshToken', refreshToken);
  return data.data;
};

export const logout = async (): Promise<void> => {
  const refreshToken = localStorage.getItem('refreshToken');
  if (refreshToken) {
    try {
      await apiClient.post(`${BASE_URL}/logout`, { refreshToken });
    } catch {
      // Ignore logout errors
    }
  }
  localStorage.removeItem('accessToken');
  localStorage.removeItem('refreshToken');
};

export const getCurrentUser = async (): Promise<User> => {
  const { data } = await apiClient.get<ApiResponse<User>>('/users/me');
  return data.data;
};
